const { TSDI } = require("tsdi");

const TSDIPrototype = TSDI.prototype;
const hasEnteredScope = TSDIPrototype.hasEnteredScope;

const isFactoryMetadata = metadata => Boolean(metadata.rtti);
const splitScope = scope => (scope ? scope.split(",") : []);

TSDIPrototype.hasEnteredScope = function(metadata) {
  const result = hasEnteredScope.call(this, metadata);

  if (!result) {
    const { scope } = metadata.options;

    if (scope) {
      return splitScope(scope).some(item => Boolean(this.scopes[item]));
    }
  }

  return result;
};

let multiScopes = [];

TSDIPrototype.getScope = function(name) {
  return {
    enter: () => {
      multiScopes.forEach(multiScope => {
        if (!multiScope.some(scope => name === scope)) {
          this.getScope(multiScope.join(",")).leave();
        }
      });
      multiScopes = [];

      splitScope(name).forEach(scope => {
        this.scopes[scope] = true;
      });
    },
    leave: () => {
      multiScopes = this.components
        .map(metadata => splitScope(metadata.options.scope))
        .filter(scopes => scopes.length > 1)
        .filter(scopes => scopes.includes(name));

      splitScope(name).forEach(scope => delete this.scopes[scope]);

      this.components
        .filter(metadata => {
          return (
            !isFactoryMetadata(metadata) &&
            (metadata.options.scope === name ||
              splitScope(metadata.options.scope).length === 1)
          );
        })
        .forEach(metadata => {
          const idx = this.getComponentMetadataIndex(
            isFactoryMetadata(metadata) ? metadata.rtti : metadata.fn
          );

          this.destroyInstance(idx, metadata);
        });
    }
  };
};
